module.exports = __webpack_public_path__ + "img/book-check-fill.b7e40bc4.svg";